import ClassroomAPI from '@/apis/business/teacher/classroom-api.js'
import StudentClassroomAPI from '@/apis/business/teacher/student-classroom-api.js'
import Subjects from './subjects'
import { Dictionary } from '@/utils/cache-data'
import { localStorage, sessionStorage } from '@/utils/storage'
import { localStorageKeys, sessionStorageKeys } from '@/common/storage-keys'

import Enumeration from '@/common/enumeration.js'
import commonFn from '@/common/common-fn'

export default {
  namespaced: true,
  state: {
    classrooms: [],
    classroom: {},
    totalInActiveClass: 0,
    visiblePopover: false,
    avaiableClassrooms: [],
    classEMISIDs: [],
    openTypeClassRoom: null,
    teachers: [],
    classroomsByGrade: [],
    students: [],
    availableClassroomRes: {},
    schoolYears: [],
    currentSchoolYear: null
  },

  getters: {
    /**
     * @description Lấy state classrooms chia thành 1 object 2 field active và inactive
     * @author NTQuy
     * @param {*} state
     * @returns
     */
    classrooms (state) {
      const activeClassrooms = state.classrooms?.filter((classroom) => {
        return classroom.InActive === false
      })
      const inactiveClassrooms = state.classrooms?.filter((classroom) => {
        return classroom.InActive === true
      })
      const activeClassroomsSort = activeClassrooms.sort((a, b) =>
        a.GradeID !== b.GradeID
          ? a.GradeID - b.GradeID
          : a.ClassName - b.ClassName
      )

      const classrooms = {
        activeClassrooms: activeClassroomsSort,
        inactiveClassrooms: inactiveClassrooms
      }
      return classrooms
    },

    /**
     * @description lấy state classroom
     * @author NTQuy
     * @param {*} state
     * @returns
     */
    getClassroom (state) {
      return state.classroom
    },

    /**
     * @description Lấy thông tin lớp đã chọn từ màn suggest
     * @author NTQuy
     * @param {*} state
     * @returns
     */
    selectedSuggestFormClassroom (state) {
      const classrooms = state.avaiableClassrooms.filter((classroom) => {
        return state.classEMISIDs.includes(classroom.ClassEMISID)
      })

      return classrooms
    },

    /**
     * @description lấy danh sách lớp tạo sẵn và lọc trùng với danh sách lớp đã tạo
     * @author NTQuy
     * @param {*} state
     * @returns
     */
    avaiableClassrooms (state) {
      // const classEMISIDs = state.classrooms?.map(classroom => {
      //   return classroom.ClassEMISID
      // })?.filter(classEMISID => {
      //   return classEMISID != null
      // })

      // const classrooms = state.avaiableClassrooms?.filter(classroom => {
      //   return !classEMISIDs.includes(classroom.ClassEMISID)
      // })
      const classrooms = state.avaiableClassrooms

      return classrooms
    }
  },

  mutations: {
    /**
     * @description set dữ liệu cho state classrooms
     * @author NTQyy
     * @param {*} state
     * @param {*} classRooms
     */
    setClassrooms (state, classrooms) {
      state.classrooms = classrooms
    },

    /**
     * @description set dữ liệu cho state ClassroomsByGrade
     * @author VHSon
     * @param {*} state
     * @param {*} ClassroomsByGrade
     */
    setClassroomsByGrade (state, classroomsByGrade) {
      state.classroomsByGrade = classroomsByGrade
    },

    // set loại lớp học để mở ra popup
    setOpenTypeClassRoom (state, openTypeClassRoom) {
      state.openTypeClassRoom = openTypeClassRoom
    },

    /**
     * Set dữ liệu cho Teacher
     * @param {*} state
     * @param {*} teachers
     * CreateBy: Nvduc
     */
    setTeachers (state, teachers) {
      state.teachers = teachers
    },

    /**
     * @description set dữ liệu cho state totalInActiveClass
     * @author NTQuy
     * @param {*} state
     * @param {*} total
     */
    setTotalInActiveClass (state, total) {
      state.totalInActiveClass = total
    },

    /**
     * @description set dữ liệu cho state classroom
     * @author NTQuy
     * @param {*} state
     * @param {*} classroom
     */
    setClassroom (state, classroom) {
      state.classroom = classroom
    },

    /**
     * @description thêm object cho state classrooms
     * @author NTQuy
     * @param {*} state
     * @param {*} classroom
     */
    addClassroom (state, classroom) {
      state.classroom = classroom
      state.classrooms.push(classroom)
    },

    /**
     *@description Chỉnh sửa lớp trong danh sách lớp
     * @param {*} state
     * @param {*} classroom
     */
    updateClassroom (state, classroom) {
      const id = classroom.Id
      const index = state.classrooms.findIndex(
        (classroom) => classroom.Id === id
      )

      state.classrooms[index] = { ...classroom }

      if (classroom.InActive) {
        state.totalInActiveClass += 1
      }
    },

    /**
     * @description Xóa lớp học trong danh sách lớp
     * @author NTQuy
     * @param {*} state
     * @param {*} id
     */

    removeClassroom (state, id) {
      const index = state.classrooms.findIndex(
        (classroom) => classroom.Id === id
      )

      state.classrooms.splice(index, 1)
    },

    /**
     * @description kích hoạt trạng thái ẩn popover
     * @author NTQuy
     */
    visiblePopover (state) {
      state.visiblePopover = !state.visiblePopover
    },

    /**
     * @description Lấy danh sách lớp được cung cấp
     * @param {*} state
     * @param {*} classrooms
     */
    setAvaiableClassroom (state, classrooms) {
      state.avaiableClassrooms = classrooms
    },

    /**
     * @description Thêm danh sách lớp học được tạo sẵn vào danh sách lớp hiện tại
     * @param {*} state
     * @param {*} classrooms
     */
    addAvaiableClassroomToClassrooms (state, classrooms) {
      if (state.classrooms.length) {
        classrooms.forEach((classroom) => {
          state.classrooms.push(classroom)
        })
      } else {
        state.classrooms = classrooms
      }
    },

    /**
     * @description thêm danh sách lớp đã chọn trong màn gợi ý sử dụng lớp tạo sẵn
     * @author NTQuy
     * @param {*} state
     * @param {*} classEMISIDs
     */
    addSelectedSuggestFormClassroom (state, classEMISIDs) {
      state.classEMISIDs = classEMISIDs
    },

    /**
     * @description set dữ liệu danh sách học sinh LMS
     * @author NVHUY1
     * @param {*} state
     * @param {*} classRooms
     */
    setStudents (state, students) {
      state.students = JSON.parse(students)
    },

    setResponeAvailableClasroom (state, res) {
      state.availableClassroomRes = res
    },

    setSchoolYears (state, res) {
      state.schoolYears = res
    },

    setCurrentSchoolYear (state, res) {
      state.currentSchoolYear = res
    }
  },

  actions: {
    /**
     * @description Gọi API lấy 1 lớp học
     * @param {*} context
     * @param {*} classroom
     * @returns
     */
    getClassroom (context, classroom) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.getClassroom(classroom)
          .then((res) => {
            context.commit('setClassroom', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Load toàn bộ lớp học từ API
     * @param {*} context
     * @author NTQuy
     */
    getClassrooms (context, param) {
      // Kiểm tra role của giáo viên có phải hội đồng hay không
      const checkOrganingCommitteeRole = commonFn.checkRoleUser(
        Enumeration.RoleDictionaryKey.OrganingCommittee
      )
      param.IsOrganingCommittee = checkOrganingCommitteeRole
      return new Promise((resolve, reject) => {
        ClassroomAPI.getAsync('/many', { params: param })
          .then((res) => {
            context.commit('setClassrooms', res.Data.Classrooms)
            context.commit('setTotalInActiveClass', res.Data.TotalInActiveClass)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách các lớp học chính quy
     * @param {*} context
     */
    // async getFormalClassrooms (context, params) {
    //   const res = await ClassroomAPI.getAsync(
    //     `/classroom-formal?schoolyear=${params || ''}`
    //   )
    //   context.commit('setClassrooms', res.Data)
    // },

    async getSchoolYears (context) {
      const res = await ClassroomAPI.getAsync('/school-years')
      context.commit('setSchoolYears', res.Data?.SchoolYears)
      return res.Data?.SchoolYears
    },

    // /**
    //  * @description lấy danh sách lớp học theo trạng thái
    //  * @author NTQuy
    //  * @param {*} context
    //  * @param {*} status
    //  * @returns
    //  */
    // getActiveClassrooms (context, isFormal) {
    //   const checkOrganingCommitteeRole = commonFn.checkRoleUser(
    //     Enumeration.RoleDictionaryKey.OrganingCommittee
    //   )
    //   return new Promise((resolve, reject) => {
    //     ClassroomAPI.getAsync(`/active/${status}`)
    //       .then((res) => {
    //         context.commit('setClassrooms', res.Data.ClassList)
    //         context.commit('setTotalInActiveClass', res.Data.TotalInActiveClass)
    //         resolve(true)
    //       })
    //       .catch((err) => {
    //         reject(err)
    //       })
    //   })
    // },

    // /**
    //  * @description lấy danh sách lớp học theo trạng thái và năm học
    //  * @param {*} context
    //  * @param {*} status
    //  * @returns
    //  */
    // getActiveClassroomsWithSchoolYear (context, params) {
    //   return new Promise((resolve, reject) => {
    //     ClassroomAPI.getAsync(
    //       `/active/${params.status}?schoolYear=${
    //         params.schoolYear ? params.schoolYear : ''
    //       }`
    //     )
    //       .then((res) => {
    //         context.commit('setClassrooms', res.Data.ClassList)
    //         context.commit('setTotalInActiveClass', res.Data.TotalInActiveClass)
    //         resolve(true)
    //       })
    //       .catch((err) => {
    //         reject(err)
    //       })
    //   })
    // },

    /**
     * @description Gọi API Thêm mới lớp học
     * @author NTQuy
     * @param {*} context
     * @param {*} classRoom
     * @returns
     */
    addClassroom (context, classroom) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.addClassroom(classroom)
          .then((res) => {
            if (res.IsSuccess) {
              context.commit('addClassroom', res.Data)
              const listGiftCards = sessionStorage.get(
                sessionStorageKeys.TEACHER_GIFT_CARD
              )
              // Giảm số lượt sử dụng trên session
              const index = listGiftCards.findIndex(
                (element) =>
                  element.GiftCardType ===
                  Enumeration.GiftCardType.ManagerClassroom
              )
              listGiftCards[index].UsedCount++
              sessionStorage.set(
                sessionStorageKeys.TEACHER_GIFT_CARD,
                listGiftCards
              )
              resolve(true)
            } else {
              reject(res.IsSuccess)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Gọi API xóa lớp học
     * @author NTQuy
     * @param {*} context
     * @param {*} id
     * @returns
     */
    deleteClassroom (context, id) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.deleteClassroom(id)
          .then((e) => {
            context.commit('removeClassroom', id)
            const listGiftCards = sessionStorage.get(
              sessionStorageKeys.TEACHER_GIFT_CARD
            )
            // Giảm số lượt sử dụng trên session
            const index = listGiftCards.findIndex(
              (element) =>
                element.GiftCardType ===
                Enumeration.GiftCardType.ManagerClassroom
            )
            listGiftCards[index].UsedCount--
            sessionStorage.set(
              sessionStorageKeys.TEACHER_GIFT_CARD,
              listGiftCards
            )
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Gọi API sửa lớp học
     * @author NTQuy
     * @param {*} context
     * @param {*} classroom
     * @returns
     */
    updateClassroom (context, classroom) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.updateClassroom(classroom.Id, classroom)
          .then(context.commit('updateClassroom', classroom), resolve(true))
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy thông tin lớp học theo mã lớp
     * @param {*} context
     * @param {*} classCode
     * @returns
     */
    getClassroomByClassCode (context, classCode) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.getAsync(`/class-code/${classCode}`)
          .then((res) => {
            context.commit('setClassroom', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách lớp được tạo sẵn
     * @author NTQuy
     * @param {*} context
     */
    async getAvaiableClassrooms (context, schoolYear) {
      const res = await ClassroomAPI.getAsync(
        `/available?schoolYear=${schoolYear}`
      )
      const classrooms = res.Data?.Classrooms
      const isChangeSchoolYear = res.Data?.IsChangeSchoolYear
      for (let index = 0; index < classrooms?.length; index++) {
        const classroom = classrooms[index]
        const subjects = JSON.parse(classroom.SubjectList)
        let subjectCodes = []
        subjectCodes = []
        subjects?.forEach((item) => {
          var tmpSubjects = Subjects.filter((subject) => {
            return subject?.Id?.some((id) => item?.SubjectEMISID === id)
          })
          subjectCodes = subjectCodes.concat(
            tmpSubjects.map((x) => x.SubjectCode)
          )
        })

        const subjectFilterDublicate = [...new Set(subjectCodes)]

        classroom.Teacher.Subjects = await Dictionary.GetSubjectsBySubjectCode(
          subjectFilterDublicate
        )
      }
      if (isChangeSchoolYear) {
        // Lấy lại schoolYear
        localStorage.remove(localStorageKeys.SCHOOL_YEAR_DATA)
        await context.dispatch('getSchoolYears').then(schoolYears => {
          localStorage.set(localStorageKeys.SCHOOL_YEAR_DATA, schoolYears)
        })
        // me.saveSchoolYear()
      }

      context.commit('setAvaiableClassroom', classrooms)
      context.commit('setResponeAvailableClasroom', res)
      return classrooms
    },

    /**
     * @description Thêm thông tin tài khoản vào lớp chính quy
     * @author NTQuy
     * @param {*} context
     * @returns
     */
    updateFormalClassroom (context, classrooms) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.putAsync('/batch', classrooms)
          .then((res) => {
            context.commit('addAvaiableClassroomToClassrooms', classrooms)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách lớp học đã được tạo sẵn với tài khoản giáo viên được nhà trường cấp
     * @author BNDung
     * @param {*} context
     * @returns
     */
    updateTotalStudent (context, classCode) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.postAsync(`teacher-update-total/${classCode}`)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description cập nhật đường dẫn vào lớp học
     * @author VDDung1
     * @param {*} context
     * @returns
     */
    updateLinkJoinClass (context, param) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.postAsync('link-join-class', param)
          .then((res) => {
            resolve(res.IsSuccess)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách giao viên và filter theo điều kiện
     * @param {*} context
     * @param {*} param
     * @returns
     * CreateBy: NVDuc 27.08
     */
    getFilterTeachers (context, classCode) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.getAsync(`${classCode}/teachers`)
          .then((res) => {
            context.commit('setTeachers', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách lớp học theo khối
     * @param {*} context
     * @param {*} GradeId
     * @returns
     * CreateBy: VHSON 06.09.2021
     */
    getClassroomByGrade (context, param) {
      return new Promise((resolve, reject) => {
        ClassroomAPI.getAsync(
          `/list-class/${param.gradeId}/${param.schoolYear}`
        )
          .then((res) => {
            context.commit('setClassroomsByGrade', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách học sinh từ bên LMS
     * @author NTQuy
     * @param {*} context
     * @returns
     */
    async getStudents (context, params) {
      const res = await StudentClassroomAPI.getAsync(
        `/available?classID=${params?.classEMISID}`
      )

      context.commit('setStudents', res.Data)
      return res.Data
    },

    /**
     * @author NVThang
     * @description update lại lớp học khi giáo viên rời lớp
     * @param {*} context
     * @param {*} classroom
     */
    async leaveClassRoom (context, classroom) {
      await ClassroomAPI.postAsync('/leaveClass', classroom)
    },

    /**
     * @author VDDung1
     * @description bỏ Tạo lớp EMIS Ôn tập khi tk hội đồng xóa lớp
     * @param {*} context
     * @param {*} classroom
     */
    async syncClearClassroomEXOL (context, param) {
      await ClassroomAPI.postAsync(
        `sync-clear-classroom?classEMISID=${param.ClassEMISID}`
      )
    }
  }
}
